$(document).ready(function () {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafari || iOS) {
        $(".positionEditBtn").click(function () {
            var orderPositionNr = $(this).data("positionnr");
            SetOrderPositionNrToEdit(orderPositionNr);
        });

        var orderPositionNr = GetOrderPositionNrToEdit();

        if (orderPositionNr) {
            var fragment = GetOrderPositionToEditFragment(orderPositionNr);
            RemoveOrderPositionNrToEdit();
            AddFragmentToCurrentUrl(fragment);
        }
    }

    function SetOrderPositionNrToEdit(orderPositionNr) {
        localStorage.setItem("orderPositionNrToEdit", orderPositionNr);
    }

    /**
     * @return {string}
     */
    function GetOrderPositionNrToEdit() {
        return localStorage.getItem("orderPositionNrToEdit");
    }

    function RemoveOrderPositionNrToEdit() {
        localStorage.removeItem("orderPositionNrToEdit");
    }

    function AddFragmentToCurrentUrl(fragment) {
        window.location.hash = fragment;
    }

    /**
     * @return {string}
     */
    function GetOrderPositionToEditFragment(orderPositionNr) {
        return "/edit/" + orderPositionNr;
    }


});